import { render, staticRenderFns } from "./cmsArticle.vue?vue&type=template&id=3eadcc68&"
import script from "./cmsArticle.vue?vue&type=script&lang=js&"
export * from "./cmsArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports